/**
 * Created by Reda on 17.08.2026
 */

const Autumn26Tutorial = function () {
    return new TutorialScenario("autumn26_tutorial", {
        manual: true,
        isAvailable: () => Map2dLocation.currentLocation && Map2dLocation.currentLocation.map.fogs.blocks.fog1,
        listSteps: () => [
            MergeTutorialHelper.createUnlockFogStep({ id: "fog0" }),
            MergeTutorialHelper.createAdviceStep({
                type: Map2d.MERGE,
                targets: { code: "dr2dragonblue", stage: 0 },
                person: "dwarf",
                text: "Tutorial.autumn26.step1",
                arrowDelay: 0.2
            }),
            MergeTutorialHelper.createAdviceStep({
                type: Map2d.MERGE,
                targets: { code: "drfruit", stage: 0 },
                person: "dwarf",
                text: "Tutorial.autumn26.step2",
                arrowDelay: 0.2
            }),
            MergeTutorialHelper.createAdviceStep({
                type: Map2d.MERGE,
                targets: { code: "drfruit", stage: 1 },
                arrowDelay: 0.2
            }),
            MergeTutorialHelper.createAdviceStep({
                type: Map2d.MERGE,
                targets: { code: "drfruit", stage: 2 },
                arrowDelay: 0.2
            }),
            MergeTutorialHelper.createAdviceStep({
                type: Map2d.SPAWN,
                targets: { code: "drfruit", stage: 3 },
                prizes: { code: "drfruit", stage: 4 },
                person: "dwarf",
                text: "Tutorial.autumn26.step3",
                arrowDelay: 0.2
            }),
            MergeTutorialHelper.createAdviceStep({
                type: Map2d.FEED_HERO,
                targets: { code: "drfruit", stage: 4 },
                person: "dwarf",
                text: "Tutorial.autumn26.step4",
                arrowDelay: 0.2,
                fingerDelay: 0.1,
                nextStepDelay: 2,
                scroll: {
                    visibleBox: {
                        left: 0.3, right: 0.4, top: 0.0, bottom: 0.15
                    }
                }
            }),
            new TutorialStep({
                onStart: function () {
                    this.type = Map2d.OPENFOG;
                    this.targets = ["fog1"];

                    Map2dLocation.currentLocation.map.fogs.calcFogStates();
                    Map2d.currentMap.advice.setLogic(Map2d.OPENFOG, { targets: this.targets });

                    if (!Map2d.currentMap.advice.hasHints()) {
                        this.finish();
                        return;
                    }

                    const move = Map2d.currentMap.advice.findMove();

                    if (!move) {
                        this.finish();
                        return;
                    }

                    cleverapps.focusManager.compound(this.finish.bind(this), [
                        function (f) {
                            MergeTutorialHelper.scrollToTarget(move.mergeCluster || [move.cells[0]], f);
                        },

                        function (f) {
                            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
                            const visibleControls = ["map2d"];
                            const hiddenControls = cleverapps.focusManager.controls.filter((control) => visibleControls.indexOf(control) === -1);

                            cleverapps.focusManager.hideControlsWhileFocused(hiddenControls);
                            cleverapps.focusManager.showControlsWhileFocused(visibleControls);
                            Map2d.currentMap.advice.startHint({
                                arrow: { delay: MergeTutorial.ARROW_DELAY },
                                finger: {
                                    delay: MergeTutorial.FINGER_DELAY,
                                    repeatDelay: 2
                                }
                            });

                            this.dialogue = MergeTutorialHelper.createMinimalDialogue({
                                person: "dwarf",
                                text: "Tutorial.autumn26.step5"
                            });

                            cleverapps.tutorial.on(Map2d.OPENFOG, f);
                        }.bind(this)
                    ]);
                },

                onFinish: function () {
                    Map2d.currentMap.advice.stopHint();
                    this.dialogue && this.dialogue.remove();

                    Map2dLocation.currentLocation.counter.trigger();
                }
            })

        ]
    });
};

Map2dLocation.TUTORIALS.push(Autumn26Tutorial);